export default __webpack_public_path__ + "static/media/ShopDark.e5f21aa1.svg";